import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer({
  className = ''
}: {
  className?: string;
}) {
  // Start at 12 hours, 45 minutes, 0 seconds
  const [timeLeft, setTimeLeft] = useState(12 * 3600 + 45 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className={`inline-flex items-center gap-2 font-mono font-bold tracking-wider ${className}`} data-id="element-216">
      <Clock className="w-4 h-4" data-id="element-217" />
      <span data-id="element-218">
        {format(hours)}:{format(minutes)}:{format(seconds)}
      </span>
    </div>;
}